
  import { IonPage  } from '@ionic/vue';
  import { useRouter } from 'vue-router';
  import { defineComponent } from 'vue';
  

  export default defineComponent({
    name: 'Login',
    components: {IonPage },
    created: function(){
      this.checkLogin();
    },
    setup() { 
      const router = useRouter();
      const spotifyConfig = {
        clientId: '5da7f93846a048c2834a174fe06e5bb9',
        redirectUri: 'https://nightingale-1d29b.web.app/app',
      };
     

      return {spotifyConfig, router}

    },
     computed: {
        // declare the type returned by your function/computed/method
        url(): string {
            return this.getLoginURL(['user-read-email playlist-modify-public playlist-modify-private']);
        }
    },
    methods:{
    redirect(){
        this.router.push('/music/recommended');
        
    },
    redirectFalse(){
        this.router.push('/app/');
    },
    login(){
      localStorage.clear();
      return new Promise((resolve, reject) => {
          window.addEventListener('message', event => {
            
            const hash = JSON.parse(event.data);
            // alert("PO")
            if (hash.type == 'access_token') {
              resolve(hash.access_token);
            }else{
              reject()
              this.router.push('/app/');
            }
          }, false);
  
          // Show spotify auth popup
          window.open(this.url,"_self");
          this.checkLogin();
        });
    },
    getLoginURL(scopes: [string]){
        return 'https://accounts.spotify.com/authorize?client_id=' + this.spotifyConfig.clientId +
            '&redirect_uri=' + encodeURIComponent(this.spotifyConfig.redirectUri) +
            '&scope=' + encodeURIComponent(scopes.join(' ')) +
            '&response_type=token&show_dialog=true&scope=playlist-read-private';
    },
     async getUserData(accessToken: string) {
      const res = await fetch( `https://api.spotify.com/v1/me`, { 'headers': {'Authorization': 'Bearer ' + accessToken }});
      const data = (await res.json());

      localStorage.setItem('userID', data.id);
      localStorage.setItem('userID', encodeURI(localStorage.getItem('userID') || ''));
      window.dispatchEvent(new CustomEvent('userID-Added', {
        detail: {
          storage: localStorage.getItem('userID')
        }
      }));

      let token=""
      this.postData({
                "data": {
                    "email":data.email,
                    "user_id": data.display_name,
                    "spotifyUrl": data.external_urls.spotify
                }
            }).then(data => {
            console.log(data.result.token); // JSON data parsed by `data.json()` call
            token=data.result.token
            return null
        }).then(data=>{
            // console.log("THIS IS DATA"+token)
            const signInResult= this.loginTheUserWithToken(token)
            // console.log(signInResult)
            return signInResult
        })

      // const dataTwo = await this.postData(data);
      // await this.loginTheUserWithToken(dataTwo);
    },

   async postData(data: Record<string, any>) {
            const url="https://us-central1-nightingale-1d29b.cloudfunctions.net/signUp";
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify(data) // body data type must match "Content-Type" header
            });
            return response.json(); // parses JSON response into native JavaScript objects
    },
   async loginTheUserWithToken(data: string) {
    //  alert(data)
            const url="https://identitytoolkit.googleapis.com/v1/accounts:signInWithCustomToken?key=AIzaSyAhMDes-KpPanP6fUHSreiP9FDAp7V15D8";
            return await fetch(url, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify({'token':`${data}`, 'returnSecureToken':true}) // body data type must match "Content-Type" header
            }).then(res =>res.json())

    },
   

    

    checkLogin(){
      if(localStorage.getItem('accesstoken') !== null){
        this.router.push('/music/recommended');
        return;
      }   
      const queryString = window.location.hash;
      const token: Array<string>[] = [];    
      queryString.replace(/^#\/?/, '').split('&').forEach(keyval => {
        const splitIndex = keyval.indexOf('=');
        if (splitIndex == -1) {
          return;
        }
        const key: string = keyval.substring(0, splitIndex);
        const val: string = decodeURIComponent(keyval.substring(splitIndex + 1));
        token.push([key,val])
        
      });
      if(token.length == 3){
        if(token[0][0] == "access_token" && token[0][1] != null){
          //alert(token[0][1]) //add token function
          localStorage.setItem('accesstoken', token[0][1])
          this.getUserData(token[0][1])
          //console.log(token[0][1])
          this.redirect()
        }
        
      }
    },
    tokenReturn(token: string){
      return token
    },
    updateFirebase(data: string) {
        console.log(data)
        // return fetch(
        //   'https://api.spotify.com/v1/me',
        //   { 'headers': {'Authorization': 'Bearer ' + accessToken } }
        // );
        return "OK"
    },

    },

    })
